import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Boatclubroadtomumbaicab() {



const cardData = {
  keyword: " Boat Club Road to Mumbai Cabs ",

headingDescription: "Velocity Cab provides reliable and comfortable Boat Club Road to Mumbai cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Boat Club Road to Mumbai convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Boat Club Road to Mumbai cab travel.",

topPlaces: [
  
  {
    title: "Film City, Goregaon",
    description: "Film City in Goregaon is the heart of India's film and television industry, spread across hundreds of acres of greenery. Travelers hiring an Innova Crysta on rent in Pune can comfortably reach this popular attraction and enjoy guided tours featuring movie sets, television studios, and behind-the-scenes experiences of Bollywood productions."
  },
  {
    title: "EsselWorld",
    description: "EsselWorld is one of India's most popular amusement parks, offering thrilling rides and entertainment for visitors of all ages. Booking an Innova Crysta on rent in Pune makes the road trip enjoyable for families and groups planning a fun-filled day. The amusement park provides exciting attractions, live performances, and adventure rides for a memorable outing."
  },
  {
    title: "Water Kingdom",
    description: "Water Kingdom is one of Asia's largest water parks and a favorite destination for families visiting Mumbai. Travelers choosing an Innova Crysta on rent in Pune can comfortably reach the park and enjoy exciting water slides, wave pools, lazy rivers, and children's play areas. It is an excellent destination for a refreshing weekend trip."
  },
  {
    title: "Mahalakshmi Temple",
    description: "Mahalakshmi Temple is one of Mumbai's oldest and most sacred Hindu temples dedicated to Goddess Mahalakshmi. Visitors traveling with an Innova Crysta on rent in Pune can comfortably explore this spiritual landmark while enjoying beautiful views of the Arabian Sea. The temple attracts thousands of devotees throughout the year and is known for its peaceful ambiance."
  },
  {
    title: "Bandra Bandstand",
    description: "Bandra Bandstand is a scenic seaside promenade famous for its beautiful coastal views, celebrity homes, and relaxing atmosphere. Renting an Innova Crysta in Pune provides a comfortable journey to this popular destination where visitors can enjoy evening walks, sea breezes, and stunning views of the Bandra-Worli Sea Link."
  },
  {
    title: "Phoenix Marketcity Mumbai",
    description: "Phoenix Marketcity is one of Mumbai's largest shopping and entertainment destinations, featuring premium brands, restaurants, gaming zones, and multiplex cinemas. Travelers booking an Innova Crysta on rent in Pune can enjoy a convenient drive for a day of shopping, dining, and family entertainment in one of the city's finest malls."
  },
  {
    title: "Sanjay Gandhi National Park",
    description: "Sanjay Gandhi National Park is one of the largest national parks located within a metropolitan city and a perfect destination for nature lovers. Travelers booking an Innova Crysta on rent in Pune can enjoy a comfortable drive to Mumbai and explore lush forests, wildlife, cycling trails, and scenic picnic spots. The park also serves as the gateway to the famous Kanheri Caves, making it an ideal attraction for families and adventure enthusiasts."
  },
  {
    title: "Elephanta Caves",
    description: "Elephanta Caves are a UNESCO World Heritage Site famous for their magnificent rock-cut temples dedicated to Lord Shiva. Visitors choosing an Innova Crysta on rent in Pune can comfortably travel to the Gateway of India before taking a ferry to Elephanta Island. The intricate carvings, historic sculptures, and peaceful surroundings make it one of Mumbai's most remarkable cultural attractions."
  },
  {
    title: "Haji Ali Dargah",
    description: "Haji Ali Dargah is one of Mumbai's most famous religious landmarks, located on a small island in the Arabian Sea. Renting an Innova Crysta in Pune ensures a smooth and relaxing journey for families and devotees visiting this iconic shrine. The beautiful Indo-Islamic architecture, scenic sea views, and peaceful atmosphere make it a must-visit destination."
  },
  {
    title: "Crawford Market",
    description: "Crawford Market is a historic marketplace known for its colonial architecture and wide variety of fresh produce, spices, dry fruits, flowers, and household goods. Visitors hiring an Innova Crysta on rent in Pune can comfortably explore this bustling market while experiencing Mumbai's vibrant local culture and shopping for unique products."
  }
],



services: [
{
name: "Boat Club Road to Mumbai Cab Price",
description: "Boat Club Road to Mumbai cab price service provides transparent fare details for passengers traveling from Boat Club Road in Pune to Mumbai city. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth expressway travel. Professional drivers provide punctual pickup services from homes, offices, and hotels around Boat Club Road."
},
{
name: "Boat Club Road to Mumbai Innova Cab",
description: "Boat Club Road to Mumbai Innova cab service offers premium SUV transportation between Pune and Mumbai. The Innova provides spacious seating and smooth highway performance suitable for family trips, corporate travel, and airport transfers."
},
{
name: "Cab Service in Boat Club Road Pune",
description: "Cab service in Boat Club Road Pune provides reliable transportation for local travel, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe rides across Boat Club Road and nearby Pune areas."
},
{
name: "Cheapest Cab Service in Boat Club Road Pune",
description: "Cheapest cab service in Boat Club Road Pune offers affordable transportation for passengers traveling locally or planning outstation trips. Budget-friendly sedan vehicles provide comfortable seating and economical travel."
},
{
name: "Boat Club Road to Dadar Cab Service",
description: "Boat Club Road to Dadar cab service offers reliable transportation between Pune and Mumbai’s Dadar area. Comfortable vehicles with experienced drivers ensure safe expressway travel."
},
{
name: "Sangamwadi to Mumbai Cabs",
description: "Sangamwadi to Mumbai cab service provides dependable transportation between Pune’s Sangamwadi area and Mumbai city. Vehicles are comfortable and suitable for long-distance highway travel."
},
{
name: "Sangamwadi to Mumbai Airport Cabs",
description: "Sangamwadi to Mumbai Airport cab service offers convenient airport transfers between Pune’s Sangamwadi area and Mumbai Airport terminals. Comfortable vehicles and professional drivers ensure smooth expressway travel."
},
{
name: "Best Cab Service Pune to Mumbai",
description: "Best cab service Pune to Mumbai provides dependable intercity transportation with comfortable vehicles and professional drivers. The service ensures safe expressway travel with flexible booking options."
},
{
name: "Yerwada to Mumbai Cab Service",
description: "Yerwada to Mumbai cab service offers reliable transportation between Pune’s Yerwada area and Mumbai city. Comfortable vehicles and experienced drivers ensure safe highway journeys."
},
{
name: "Cab Service in Yerwada Pune",
description: "Cab service in Yerwada Pune provides convenient transportation for city rides, airport transfers, and outstation journeys. Vehicles are comfortable and suitable for daily commuting and long-distance travel."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune offers reliable transportation for local rides, airport transfers, and long-distance journeys. Comfortable vehicles and professional drivers ensure safe travel across Pune."
},
{
name: "Cab Service in Bund Garden Pune",
description: "Cab service in Bund Garden Pune provides dependable transportation for passengers traveling within Pune or planning outstation trips. Vehicles are comfortable and suitable for city and highway travel."
},
{
name: "Bund Garden to Mumbai Cab",
description: "Bund Garden to Mumbai cab service offers reliable transportation between Pune’s Bund Garden area and Mumbai city. Comfortable vehicles and experienced drivers ensure safe expressway travel."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides dependable airport transportation for passengers traveling from Pune to Mumbai Airport terminals. Comfortable vehicles ensure smooth highway travel."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service provides reliable intercity transportation between Pune and Mumbai. Comfortable vehicles and professional drivers ensure safe expressway travel."
},
{
name: "Boat Club Road Taxi Service",
description: "Boat Club Road taxi service offers reliable transportation for local rides, airport transfers, and outstation journeys. Comfortable vehicles and experienced drivers ensure safe travel across Pune."
},
{
name: "Boat Club Road to Mumbai Cab",
description: "Boat Club Road to Mumbai cab service provides dependable transportation between Pune and Mumbai. Comfortable vehicles and professional drivers ensure safe highway travel."
},
{
name: "Boat Club Road to Mumbai Taxi",
description: "Boat Club Road to Mumbai taxi service offers convenient travel options for passengers traveling between Pune and Mumbai. Vehicles are comfortable and suitable for expressway journeys."
},
{
name: "Boat Club Road to Mumbai Cab Service",
description: "Boat Club Road to Mumbai cab service provides reliable transportation between Pune and Mumbai with professional drivers ensuring safe and smooth highway travel."
}
],

tableData: [
["Boat Club Road to Mumbai Cab Price","Boat Club Road to Mumbai Innova Cab"],
["Cab Service in Boat Club Road Pune","Cheapest Cab Service in Boat Club Road Pune"],
["Boat Club Road to Dadar Cab Service","Sangamwadi to Mumbai Cabs"],
["Sangamwadi to Mumbai Airport Cabs","Best Cab Service Pune to Mumbai"],
["Yerwada to Mumbai Cab Service","Cab Service in Yerwada Pune"],
["Cab Service in Pune","Cab Service in Bund Garden Pune"],
["Bund Garden to Mumbai Cab","Pune to Mumbai Airport Cab"],
["Pune Mumbai Cab","Boat Club Road Taxi Service"],
["Boat Club Road to Mumbai Cab","Boat Club Road to Mumbai Taxi"],
["Boat Club Road to Mumbai Cab Service","Boat Club Road to Mumbai Cab Price"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who frequently travel from Boat Club Road to Mumbai via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Boat Club Road to Mumbai cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Boat Club Road to Mumbai cab service operates 24 hours a day. Whether you need an early morning airport transfer, corporate travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Boat Club Road to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Boat Club Road",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and business locations across Boat Club Road and nearby areas like Bund Garden, Koregaon Park, Dhole Patil Road, and Sangamvadi."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Boat Club Road to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Boat Club Road to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Boat Club Road to Mumbai with professional drivers and comfortable vehicles." },
  { question: "How far is Boat Club Road from Mumbai?", answer: "The distance between Pune and Mumbai is roughly 146–150 km by road depending on the route taken." },
  { question: "Is Boat Club Road to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Boat Club Road to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Boat Club Road to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Boat Club Road and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and residential complexes across Boat Club Road." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Boat Club Road to Mumbai cab services online or through phone booking." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and other major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Abhishek Kulkarni",
    feedback:
      "My trip from Boat Club Road to Mumbai with Velocity Cabs was seamless from start to finish. The driver was courteous, the cab was well-maintained, and the journey was comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meenal Joshi",
    feedback:
      "Velocity Cabs provided a reliable cab service for my Boat Club Road to Mumbai travel. The pickup was punctual, the vehicle was clean, and I reached my destination safely and on time.",
    rating: 5
  }
];





































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Boat Club Road to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Boat Club Road to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis including Innova, Ertiga, and Sedan cabs for airport transfers, Dadar, Sangamwadi, Yerwada, and other destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Boat Club Road to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Boat Club Road to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Boat Club Road to Mumbai cab with Velocity Cabs. Affordable one way, round trip & airport drop taxis including Innova, Ertiga & Sedan for Dadar, Sangamwadi & Yerwada." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/27.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Boatclubroadtomumbaicab;